/* eslint-disable no-unused-expressions */
/* eslint-disable camelcase */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, { useContext, useEffect, useState, ReactNode } from 'react';
import { useTheme, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';
import { SectionHeader } from '@mummssoftware/common-ui';
import { FAJITA } from '@mummssoftware/utils/constants';
import { getFormListV2 } from '@mummssoftware/utils/pimReader';
import { GlobalContext, SET_FAJITA_FORM } from '@mummssoftware/global-context';
import { AgGridReact } from 'ag-grid-react';
import { GridApi, GridOptions } from 'ag-grid-community';
import { useIntl } from 'react-intl';
import { messages } from './messages';
import { FormsContext } from '../../context';
import {
  ACTIVE,
  FORM_NAME,
  IN_PROGRESS,
  IN_PROGRESS_FAJITA,
  questionnaireEngine,
} from '../Form/constants';
import { MessageOverlay } from './MessageOverlay';
import {
  activeFormsList,
  comingSoonFormsList,
  FormName,
  FormioName,
} from './constants';
import defaults from '../../translations/en.json';

import 'ag-grid-community/dist/styles/ag-grid.css';
import '@mummssoftware/common-ui/style/css/ag-theme-hummingbird.css';

const PatientListFormsWrapper = styled.div<{ embedded?: boolean }>`
  overflow: hidden;
  height: 75vh;
  padding-bottom: 28px;
  ${(props) => (props.embedded ? `max-height: 465px;` : `max-height: 200px;`)}
`;

type PatientListFormsProps = {
  embedded?: boolean;
};

const useStyles = makeStyles((theme) => ({
  header: {
    position: 'relative',
    padding: '6px 8px',
    '& h6': {
      fontSize: '1rem',
    },
  },
  listError: {
    padding: '8px 12px',
    color: theme.palette.error.main,
  },
}));

/** Beginning of functional component */
export const PatientListForms = ({ embedded }: PatientListFormsProps) => {
  const {
    props: {
      grid: gridTheme = {
        className: '',
        rowHeight: 25,
        headerHeight: 25,
      },
    },
  } = useTheme() as any;
  const intl = useIntl();
  const classes = useStyles();
  const { pathname, search } = window.location;
  const columnHeaderName = intl.formatMessage(messages.chooseQuestionnaire);
  const [rows, addRowData] = useState<any | undefined>(undefined);
  const [questionnaireEngineShown, showQuestionnaireEngine] = useState<
    string | undefined
  >(undefined);
  const [qeHtml, setQEHtml] = useState<string | undefined>(undefined);
  const [gridApi, setGridApi] = useState<GridApi | null>(null);

  const { appVisit } = useContext(GlobalContext);
  const globalContext = useContext(GlobalContext);

  const {
    onClick,
    menuClick,
    agency,
    patient,
    pim,
    currentUser,
    keycloak,
    database,
    siteId,
    isPgba,
  } = useContext(FormsContext);

  const [visitID, setVisitID] = useState<number>();
  const [formListError, setFormListError] = useState<string | null>(null);

  const getFormDisplayText = (form: FormName) =>
    intl.formatMessage(messages.forms[form]);

  const activeFormsData = activeFormsList.length
    ? activeFormsList.map((form: FormName) => ({
        key: form,
        status: 'active',
        className: 'active',
        displayText: getFormDisplayText(form),
        embedded,
        source: 'formio',
        sticky: '',
        inProgress: false,
      }))
    : [];
  const comingSoonFormsData = comingSoonFormsList.map((form: FormName) => ({
    key: form,
    status: 'comingSoon',
    className: 'disabled',
    displayText: `${getFormDisplayText(form)}`,
    embedded,
    source: 'formio',
    sticky: '',
    inProgress: false,
  }));

  // sequence matters here
  let allFormsData: any = [];

  const firm = currentUser.hbcFirm;
  // TODO set this back once the currentUser call starts returning the correct site id
  // currentUser.siteId is only returning the default site id and not the current
  // site id the user is in.
  // const currentSite = currentUser?.siteList?.filter(
  //   (s) => s.id === currentUser.siteId,
  // )[0];
  const location =
    currentUser?.siteList?.filter((s) => `${s.id}` === siteId)[0]
      ?.hbcLocation || '';

  const attemptFetch = async (url: string) => {
    const headers = new Headers();
    if (!keycloak?.token) {
      keycloak.logout();
      return;
    }
    headers.set('keycloakToken', keycloak.token);

    // eslint-disable-next-line consistent-return
    return fetch(`${url}`, {
      headers,
      credentials: 'include',
    });
  };

  const QuestionnaireEngine = async (iframe: string) => {
    showQuestionnaireEngine(undefined);
    const getHtml = () => {
      let res;
      return attemptFetch(iframe)
        .then(async (_res) => {
          res = _res;
          console.log('_res', _res);
          if (res && !res.ok) {
            return '';
          }
          return res && res.text();
        })
        .catch((e: any) => console.error('e', e));
    };
    const preHtml = await getHtml();
    if (preHtml) {
      setQEHtml(
        preHtml
          .replaceAll('src="/', `src="${process.env.REACT_APP_HBC_BASE_URL}/`)
          .replaceAll(
            'href="/',
            `href="${process.env.REACT_APP_HBC_BASE_URL}/`,
          ),
      );
      showQuestionnaireEngine(iframe);
    }
  };

  const updateInProgress = (inProgPatient: any) => {
    // TODO UPDATE IN PROGRESS !!!
    if (!inProgPatient || !inProgPatient.questionnaires) {
      return;
    }

    let changed = false;
    const inProgress: any[] = [];
    inProgPatient?.questionnaires.forEach((q: any) => {
      inProgress.push(q.questionnaire['@id']);
    });
    rows?.forEach((row: any) => {
      const prev = row.inProgress;
      row.inProgress = inProgress.includes(row.key);
      if (row.inProgress !== prev) {
        changed = true;
        row.className = row.inProgress ? IN_PROGRESS : ACTIVE;
      }
    });
    if (changed) {
      addRowData(rows);
      gridApi?.redrawRows();
    }
  };
  // this reloads the forms list when a new visit is initiated in DashboardContext
  useEffect(() => {
    const getData = async () => {
      await getQuestionnaireEngineForms(appVisit);
    };
    if (appVisit) {
      setVisitID(appVisit.id);
    }
    getData();
  }, [appVisit]);

  const getQuestionnaireEngineForms = async (isVisitRecording?: any) => {
    // if visit recording TIMING issue with headers
    if (!agency && !patient) {
      return;
    }
    // @note : do we still need this?
    if (!keycloak?.token) {
      keycloak.logout();
      return;
    }
    // formio forms
    addRowData(allFormsData);
    setFormListError(null);

    const levelOfCare = appVisit ? appVisit.levelofcareshortname : patient?.loc;

    let questionnaireEngineForms: any[] = [];
    try {
      const formList = await getFormListV2({
        keycloak,
        pim,
        agency: agency as string,
        currentUser,
        patient: patient as mumms.patient,
        levelOfCare,
      });
      questionnaireEngineForms = (formList ?? []) as any[];
    } catch (e) {
      console.error('getQuestionnaireEngineForms: getFormListV2 failed', e);
      setFormListError(defaults.errorFormList);
      return;
    }

    const ptObj = (await database?.retrieve(patient?.patientNumber)) as any;
    // C2 In Progress forms
    const inProgress: any[] = [];
    ptObj?.questionnaires?.forEach((q: any) => {
      inProgress.push(q?.questionnaire['@id']);
    });

    const isPreviewMode = window.env?.ignoreFormVisitReq;

    const activeFormsDataWithQEForms = questionnaireEngineForms.length
      ? questionnaireEngineForms
          .reduce(function (
            allForms: any[],
            qeForm: {
              clinical_questionnaire_id: any;
              form_name: any;
              clinical_stickywhen: any;
              iscriteriamet: boolean;
              isvisitrequired: boolean;
              formtechtype: mumms.FormTech; // FAJITA or C2
              formkey: string;
              patientmanifest_id: string;
              statusforpatientperson: string;
            },
          ) {
            const isInProgressC2 = inProgress.includes(
              qeForm.clinical_questionnaire_id,
            );
            const isFAJITAForm = qeForm.formtechtype === FAJITA;
            const isInProgressFAJITA =
              qeForm.formtechtype === FAJITA &&
              qeForm.statusforpatientperson === IN_PROGRESS_FAJITA;
            // FAJITA and C2
            const isInProgress =
              qeForm.formtechtype === FAJITA
                ? isInProgressFAJITA
                : isInProgressC2;
            const formSource = isFAJITAForm ? FAJITA : questionnaireEngine;
            const validForm = (form: any) =>
              isVisitRecording
                ? form.iscriteriamet
                : form.iscriteriamet && !form.isvisitrequired;
            let validToShow;
            // admin users don't get to that part of the code, why here?
            const showForm = (form: any) =>
              currentUser.isMumms ? true : validForm(form);
            // isFAJITAForm do not have clinical_questionnaire_id
            if (isPreviewMode) {
              validToShow = true;
            } else if (isFAJITAForm) {
              validToShow = showForm(qeForm);
            } else if (!qeForm.clinical_questionnaire_id) {
              validToShow = false;
            } else {
              validToShow = showForm(qeForm);
            }
            return validToShow
              ? allForms.concat({
                  key: qeForm.clinical_questionnaire_id,
                  status: ACTIVE,
                  className: isInProgress ? IN_PROGRESS : ACTIVE,
                  displayText: qeForm.form_name,
                  embedded,
                  source: formSource, // questionnaireEngine | FAJITA
                  sticky:
                    qeForm.clinical_stickywhen === 'always' ? 'yes' : 'no',
                  inProgress: isInProgress,
                  isInProgressFAJITA,
                  ...qeForm,
                })
              : allForms;
          }, activeFormsData)
          .sort((a: any, b: any) => a.displayText.localeCompare(b.displayText))
      : activeFormsData;

    allFormsData = isVisitRecording
      ? [
          // remove sandbox forms if visit is open
          ...activeFormsDataWithQEForms.filter(
            (form: any) => !form.issandboxform,
          ),
          ...comingSoonFormsData,
        ]
      : (allFormsData = [...activeFormsDataWithQEForms]);
    addRowData(allFormsData);
  };

  const handleOnClick = (data: any) => {
    const { key, formkey, source, sticky } = data;
    const formKey = key || formkey;
    let nameFormNew = formKey; // cast to variable (necessary to avoid eslint errors)
    // C2 forms
    if (source === questionnaireEngine) {
      nameFormNew = `${questionnaireEngine}:${formKey}:${sticky}`;
    }
    // Fajita Forms
    if (source === FAJITA) {
      nameFormNew = `${FAJITA}:${formKey}`;
      globalContext.dispatch({
        type: SET_FAJITA_FORM,
        payload: data as mumms.FajitaForm,
      });
      // window.history.pushState({}, '', `/${nameFormNew}`);
      // window.location.reload();
    }
    // issue of timing with on Click as it reload the component and SET_FORM_NAME is reset
    // onClick to get the window to expand
    if (onClick) {
      // @note used in Body to know what view to display
      // C2 Forms => QUESTIONNAIRE engine
      // FAJITA Forms => FAJITA engine
      // Covid and IDG Forms => FORMIO engine
      // @note used in index to determine formName
      localStorage.setItem(FORM_NAME, nameFormNew);
    }
    // this menuClick isolates clicks and calls the prop method from FormListMenu
    if (menuClick && embedded) {
      const formData = {
        nameForm: nameFormNew,
        formTitle: '',
        source,
        location,
        idg: false,
      };
      menuClick(formData);
    }
  };

  // was getting an error about state being readonly, that's why the below is necessary
  type CellProps = any;
  const chooseCell = (props: CellProps) => createCell(props);

  /**
   * createCell looks to be the cell renderer that we are using to make the custom grid.
   *
   * @param props   // createCell looks to be the cell renderer that we are using to make the custom grid
   * @returns
   */
  const createCell = (props: any) => {
    const {
      key,
      className,
      embedded: isEmbedded,
      source,
      sticky,
      inProgress,
      displayText,
      formkey,
    } = props.data;
    // todo issue
    const fullText = inProgress ? `${displayText} (In Progress)` : displayText;

    const formKey = key || formkey;
    let node: ReactNode;
    if (className === 'disabled') {
      node = <div className={className}>{fullText}</div>;
    } else if (isEmbedded || source === FAJITA) {
      // forms inside dashboard
      node = (
        <a className={className} onClick={() => handleOnClick(props.data)}>
          {fullText}
        </a>
      );
    } else if (!isEmbedded) {
      // STAND ALONE FORMS
      if (source === questionnaireEngine) {
        // C2
        node = (
          <a
            className={className}
            onClick={() =>
              QuestionnaireEngine(
                `${process.env.REACT_APP_HBC_BASE_URL}/m2/questionnaireEngine/${firm}/${location}/${patient?.patientNumber}?id=${key}&visitID=${visitID}&sticky=${sticky}&loggedInWithSSO=true`,
              )
            }
          >
            {fullText}
          </a>
        );
      } else if (source === FAJITA) {
        // FAJITA
        node = (
          <a className={className} href={`${pathname}/${FAJITA}${search}`}>
            {fullText}
          </a>
        );
      } else {
        // FORMIO
        node = (
          <a className={className} href={`${pathname}/${formKey}${search}`}>
            {fullText}
          </a>
        );
      }
    }

    return node as ReactNode;
  };

  const gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: columnHeaderName,
        cellClass: 'no-border',
        field: 'chooseQuestionnaire',
        // use cellRendererFramework for returning JSX
        cellRendererFramework: chooseCell,
      },
    ],
    onGridReady: async (params: any) => {
      const gridAPI: GridApi = params.api;
      setGridApi(gridAPI);
      gridAPI.sizeColumnsToFit();
    },
  };

  setTimeout(async () => {
    const ptObj = (await database?.retrieve(patient?.patientNumber)) as any;
    updateInProgress(ptObj);
  }, 3000);

  database?.destroyWatchers(patient?.patientNumber);
  database?.watchItem(patient?.patientNumber, updateInProgress);

  const frameworkComponents = {
    customLoadingOverlay: MessageOverlay,
  };

  /**
   * Add other forms as "coming soon".
   */
  // todo adjust height and SectionHeader
  return (
    <PatientListFormsWrapper
      id="form-list"
      className={`${gridTheme.className} light`}
      embedded={embedded}
    >
      {questionnaireEngineShown ? null : (
        <SectionHeader
          classes={{
            root: classes.header,
          }}
          title={defaults['forms-common']['choose-questionnaire']}
        />
      )}
      {formListError ? (
        <Typography className={classes.listError} variant="body2">
          {formListError}
        </Typography>
      ) : null}
      <AgGridReact
        gridOptions={gridOptions}
        rowData={rows}
        rowHeight={gridTheme.rowHeight}
        // frameworkComponents={frameworkComponents}
        // loadingOverlayComponent="customLoadingOverlay"
      />
    </PatientListFormsWrapper>
  );
};

export default PatientListForms;
